import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {UseFormReturn} from 'react-hook-form';
import SelectPresenter from '../../components/SelectPresenter';

interface EditRoomPresenterTabProps {
    useForm: UseFormReturn;
}

function EditRoomPresenterTab({useForm}: EditRoomPresenterTabProps): JSX.Element {
    const {t} = useTranslation();

    const {watch} = useForm;

    const presenterId = watch('presenterId');

    const [presenterSearchTerm, setPresenterSearchTerm] = useState<string>('');
    return (
        <div>
            <div className="c-editRoomModal__content_header">{t('roomsPage.editRoomModal.presenter')}</div>

            <div className="u-mt-4">
                <div className="u-flex u-h-between u-h-left u-v-center c-room_modal__input__text">
                    <div>{`${t('roomsPage.createRoomModal.presenter')}`}</div>
                </div>
                <SelectPresenter
                    presenterId={presenterId}
                    presenterSearchTerm={presenterSearchTerm}
                    setPresenterSearchTerm={setPresenterSearchTerm}
                    useForm={useForm}
                />
            </div>
        </div>
    );
}

export default EditRoomPresenterTab;
